import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'notification';

const NotificationService = {
  getInitFormData() {
    return {
      title: '',
      body: '',
      link: '',
      icon: null,
      invoiceId: null,
      createdAt: new Date()
    };
  },
  send(data) {
    return Http.post(`/${RESOURCE_NAME}/send`, data);
  },
  pushNoIdentity(data) {
    return Http.post(`/${RESOURCE_NAME}/push-to-no-identity`, data);
  },
  upload(file) {
    let formData = new FormData();
    formData.append('image', file);
    // upload file
    return Http.post(`/${RESOURCE_NAME}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};

export default NotificationService;
